(function() {
    'use strict';
    
a3_cabin_reports.factory('FirstAidKitFactory', FirstAidKitFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FirstAidKitFactory
    * @description 
    *   Manage Report's FirstAidKits.
    * @ngInject
    */
function FirstAidKitFactory(GenericModalFactory) {

        /**
         * Initialiaze FirstAidKit object 
         * @memberof FirstAidKitFactory
         */
		function FirstAidKit() {
			this.Id = null;
			this.Position = null;
			this.SealFound = null;
			this.SealLeft = null;
            this.IsEMK = false;
		}
		
		var service = {
			createNew : createNew,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			deleteFromList : deleteFromList
		}
	
        /**
         * Create a new FirstAidKit object 
         * @memberof FirstAidKitFactory
         * @returns {object} FirstAidKit
         */			 
		function createNew() {
			return GenericModalFactory.createNew(FirstAidKit)
		}

        /**
         * Extend given FirstAidKit object 
         * @memberof FirstAidKitFactory
         * @param {object} obj The FirstAidKit object that will be extended
         * @returns {object} FirstAidKit
         */   
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,FirstAidKit)
		}

        /**
         * Delete FirstAidKit object from given list
         * @memberof FirstAidKitFactory
         * @param {object} obj The FirstAidKit object that will be deleted
         * @returns {array} FirstAidKits
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}
    
        /**
         * Extend given FirstAidKit object List 
         * @memberof FirstAidKitFactory
         * @param {object} obj The FirstAidKit object that will be extended
         * @returns {array} FirstAidKits
         */  
		function fromObjectList(objList) {
			return GenericModalFactory.fromObjectList(objList,FirstAidKit)
		}

		return service;
	}

})();
